import { Anchor, AppShell, Box, Space, Stack, Text } from "@mantine/core";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { features } from "shared/graphql/features";
import { useColorMode } from "shared/hooks/useColorMode";
import { useTheme } from "shared/utils/theme";

const Page = () => {
    const { isDark } = useColorMode();
    const { colors } = useTheme();

    features.useLoader();
    features.useGuard("HAS_WEB_OPT_IN");

    return (
        <AppShell>
            <AppShell.Main>
                <Stack w="100%" pt="lg" h="100vh" style={{ overflowY: "auto", background: isDark ? colors.dark[6] : colors.gray[2] }}>
                    <Outlet />

                    <Space flex={1} />

                    <Box py="xl" bg="gray-accent" ta="center" style={{ borderRadius: "4px" }}>
                        <Text size="sm">
                            Powered by{" "}
                            <Anchor fw="bold" td="none" href="https://bryx.com/bryx-mns">
                                Bryx Alerts
                            </Anchor>
                        </Text>
                    </Box>
                </Stack>
            </AppShell.Main>
        </AppShell>
    );
};

/** @public */
export const Route = createFileRoute("/opt-in/_layout")({
    component: Page,
    async beforeLoad() {
        await features.load();
    },
});
